import script from "./SafetySectionGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SafetySectionGroup.vue?vue&type=script&setup=true&lang=js"

import "./SafetySectionGroup.vue?vue&type=style&index=0&id=9a08e864&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a08e864"]])

export default __exports__